// Inhalt des Sheets „More“ der Bottom-Nav (UX §2.8): übrige Rail-Ziele, Plattformen, Konto,
// Theme und Abmelden.
import { ListMenu, type ShellNavItem, ThemeToggle } from '@bar/ui/basis';
import { SignOut, Sparkle, UserGear } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export interface MoreSheetProps {
  items: readonly ShellNavItem[];
  /** Eintrag „Bar Admin“ (nur mit Recht), Monogramm als `leading`. */
  admin?: { label: string; leading?: ReactNode };
  onSignOut: () => void;
  close: () => void;
}

export function MoreSheet({ items, admin, onSignOut, close }: MoreSheetProps) {
  return (
    <>
      <ListMenu
        onDone={close}
        sections={[
          {
            id: 'places',
            items: items.map((i) => ({
              id: i.id,
              label: i.label,
              icon: i.icon,
              href: i.href,
              reload: i.reload,
              active: i.active,
            })),
          },
          {
            id: 'platforms',
            items: [
              { id: 'ai', label: 'Bar AI', icon: Sparkle, href: '/ai/', reload: true },
              { id: 'account', label: 'Account settings', icon: UserGear, href: '/account' },
              ...(admin
                ? [
                    {
                      id: 'admin',
                      label: admin.label,
                      leading: admin.leading,
                      href: '/admin/',
                      reload: true,
                    },
                  ]
                : []),
            ],
          },
        ]}
      />
      <div className="flex min-h-12 items-center justify-between gap-3 px-3">
        <span className="text-body text-fg">Theme</span>
        <ThemeToggle size="sm" />
      </div>
      <ListMenu
        onDone={close}
        sections={[
          {
            id: 'out',
            items: [{ id: 'signout', label: 'Sign out', icon: SignOut, onSelect: onSignOut }],
          },
        ]}
      />
    </>
  );
}
